var $ = require('jquery');
var WS = require('../../scripts/ws.js');

$(function () {
    function loadHeaderSecondaryNav(el) {
        const $el = $(el);
        const headerDatasource = $el.data('ws-datasource');
        const revision = $el.data('ws-revision'); // Generated whenever a publish occurs, used as a cache buster
        
        if (!headerDatasource) {
            return;
        }

        const url = `${WS.cssAndJsServerUrl}/api/sitecore/HeaderApi/GetHeaderSecondaryNavHtml?headerDatasource=${headerDatasource}&revision=${revision}`;

        // Get secondary nav html and replace each secondary nav element within the primary nav
        $.get(url)
        .then(data => {
            const $data = $(data);
            $data.each(function (index) {
                const $navItem = $(this);
                const navItemDatasource = $navItem.data('ws-datasource');
                if (navItemDatasource) {
                    let $targetEl = $el.find(`[data-ws-datasource='${navItemDatasource}']`);
                    if ($targetEl.length) {
                        $targetEl.replaceWith($navItem);
                    }
                }
            });
        })
        .always(err => {
            // Indicate that the secondary nav was loaded (checked in nav.js as a prerequisite to initialization of the nav DOM events)
            // If the secondary nav failed to load, we still want to do this so the mobile hamburger menu can still be opened
            $el.data('ws-datasource-loaded', true);
        }); 
    }

    $('.ws-nav__main').each(function (index, item) {
        loadHeaderSecondaryNav(item);
    });
});